import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Paper,
  Button,
  Box,
  Typography,
  CircularProgress,
  Chip,
  debounce,
} from "@mui/material";
import { styled } from "@mui/material";
import { useDispatch } from "react-redux";
import {
  fetchUserGoalData,
  fetchUserGoalDataScroll,
  fetchUserGoalDataSearch,
} from "../../../action/userGoals";
import { isArray } from "jquery";
import GoalComponent from "./GoalComponent";
import VideoSkeleton from "./VideoSkeleton";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useSkipFirstRender } from "../../../hooks/useSkipFirstRender";
import CategoryComponent from "../CategoryComponent/Index";
import { useDebounce } from "../../../hooks/useCustomDebounce";
import ClubGoalComponent from "./ClubGoalComponent";
import { useSelector } from "react-redux";
import { getAllClubsApiScroll } from "../../../features/allClubs.slice";

const ClubListing = ({}) => {
  const token = useSelector((state) => state.auth.token);
  const allClubGoals = useSelector((state) => state.allClubs);
  const [loading, setLoading] = useState(false);
  const [clubData, setClubData] = useState(null);
  const loadMoreRef = useRef(null);
  const [scrollLoading, setScrollLoading] = useState(false);
  const [noMoreMessage, setNoMoreMessage] = useState(false);
  const page = useRef(1);
  const goalsRef = useRef([]);
  const dispatch = useDispatch();
  /// for user scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          if (!allClubGoals.hasMore) {
            setNoMoreMessage(true);
            setTimeout(() => {
              setNoMoreMessage(false);
            }, 2000);
            return;
          }
          // setScrollLoading(true);

          page.current++;
          dispatch(getAllClubsApiScroll({ token, page: page.current }));
        }
      },
      {
        threshold: 0.5,
      },
    );

    const currentRef = loadMoreRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [clubData]);

  useEffect(() => {
    setLoading(allClubGoals.loading);
    setClubData(allClubGoals.data);
    setScrollLoading(allClubGoals.scrollLoading);
  }, [allClubGoals]);


  return (
    <Box
      className="goal-wrapper"
      sx={{ backgroundColor: "#191b2f", minHeight: "calc( 100vh - " }}
    >
      {loading ? (
        Array.from({ length: 10 }).map((ele, index) => (
          <VideoSkeleton key={index} />
        ))
      ) : Array.isArray(clubData) && clubData.length > 0 ? (
        clubData.map((ele, index) => {
          if (index == clubData.length - 1) {
            return (
              <Box
                className="goal-main"
                key={ele.id}
                ref={(element) => {
                  goalsRef.current[index] = { id: ele.id, element };
                }}
                sx={{ backgroundColor: "#242743" }}
              >
                <ClubGoalComponent data={ele} />

                {scrollLoading ? (
                  <Box
                    sx={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "20px",
                    }}
                  >
                    <CircularProgress />
                  </Box>
                ) : (
                  <div
                    ref={loadMoreRef}
                    className="loadMore"
                    style={{ height: "10px", width: "10px" }}
                  ></div>
                )}
                {noMoreMessage ? (
                  <Box
                    sx={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    <Chip
                      variant="outlined"
                      color="warning"
                      label="No More Goals"
                    />
                  </Box>
                ) : (
                  ""
                )}
              </Box>
            );
          } else {
            return (
              <Box
                key={ele.id}
                ref={(element) => {
                  goalsRef.current[index] = { id: ele.id, element };
                }}
                className="goal-main"
                sx={{ backgroundColor: "#242743" }}
              >
                <ClubGoalComponent data={ele} />
              </Box>
            );
          }
        })
      ) : (
        <Box
          sx={{
            minHeight: "500px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography component="p" sx={{ color: "#6f7081", fontSize: "28px" }}>
            No Goal Data Found
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ClubListing;
